import { mapSaSwapProducts } from '../utils';

export const getDefaultSelectedPlanVariant = (sub, products) => {
  if (!products.length || !sub) {
    return null;
  }

  const subProductId = mapSaSwapProducts(sub.external_product_id.ecommerce);

  const product = products.find(
    (product) => product.external_product_id === subProductId,
  );
  if (!product) {
    return null;
  }

  const variant = product.variants.find((variant) => {
    const price = variant?.prices?.[0]?.unit_price;
    return (
      variant.external_variant_id === sub.external_variant_id.ecommerce &&
      price &&
      parseFloat(price)
    );
  });

  return variant ? variant : null;
};
